import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, AlertCircle } from 'lucide-react';
import { apiClient } from '../../utils/apiHelper';

const LibraryFineReport = () => {
  const [fines, setFines] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchFines(); }, []);

  const fetchFines = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/api/library/fines');
      setFines(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error:', error);
      // Fallback - try to get from incomes with Library Fine category
      try {
        const incomes = await apiClient.get('/api/accounts/incomes?limit=10000');
        const libraryFines = (incomes.data || []).filter(i => 
          i.category?.toLowerCase().includes('library') && i.category?.toLowerCase().includes('fine')
        );
        setFines(libraryFines);
      } catch (e) {
        console.error('Fallback error:', e);
      }
    } finally {
      setLoading(false);
    }
  };

  const totalFines = fines.reduce((sum, f) => sum + (f.amount || 0), 0);

  return (
    <div className="p-6 space-y-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <AlertCircle className="w-5 h-5 text-red-600" />
            Library Fine Report
          </CardTitle>
          <Button onClick={fetchFines} disabled={loading}>
            <FileText className="w-4 h-4 mr-2" />{loading ? 'Loading...' : 'Refresh'}
          </Button>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="p-4 bg-red-50 rounded-lg border border-red-200">
              <p className="text-sm text-red-600">Total Fine Entries</p>
              <p className="text-2xl font-bold text-red-700">{fines.length}</p>
            </div>
            <div className="p-4 bg-green-50 rounded-lg border border-green-200">
              <p className="text-sm text-green-600">Total Fine Collected</p>
              <p className="text-2xl font-bold text-green-700">₹{totalFines.toLocaleString('en-IN')}</p>
            </div>
          </div>

          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b bg-gray-50">
                <th className="text-left p-3">Date</th>
                <th className="text-left p-3">Description</th>
                <th className="text-left p-3">Payment Mode</th>
                <th className="text-right p-3">Fine Amount</th>
              </tr>
            </thead>
            <tbody>
              {fines.length === 0 ? (
                <tr><td colSpan="4" className="text-center p-8 text-gray-500">No library fine records found.</td></tr>
              ) : (
                fines.map((fine, idx) => (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="p-3">{fine.income_date || fine.date}</td>
                    <td className="p-3">{fine.description || 'Late Return Fine'}</td>
                    <td className="p-3">
                      <span className={`px-2 py-1 text-xs rounded-full ${fine.payment_mode === 'Cash' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {fine.payment_mode || 'N/A'}
                      </span>
                    </td>
                    <td className="p-3 text-right text-red-600 font-semibold">₹{fine.amount?.toLocaleString('en-IN')}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default LibraryFineReport;
